import {
  createContext,
  PropsWithChildren,
  ReactElement,
  useContext,
  useMemo,
  useState
} from 'react'

interface ScreenTitleContextValue {
  title: string | null
  titleAccessory: ReactElement<any> | null
  setTitle: (title: string | null) => void
  setTitleAccessory: (titleAccessory: ReactElement<any> | null) => void
}

export const ScreenTitleContext = createContext<ScreenTitleContextValue>({
  title: null,
  titleAccessory: null,
  setTitle: () => {},
  setTitleAccessory: () => {}
})

export const useScreenTitle = () => {
  return useContext(ScreenTitleContext)
}

export const ScreenTitleProvider = ({
  children
}: PropsWithChildren<unknown>) => {
  const [title, setTitle] = useState<string | null>(null)
  const [titleAccessory, setTitleAccessory] =
    useState<ReactElement<any> | null>(null)

  const contextValue = useMemo(
    () => ({ title, titleAccessory, setTitle, setTitleAccessory }),
    [title, titleAccessory]
  )

  return (
    <ScreenTitleContext.Provider value={contextValue}>
      {children}
    </ScreenTitleContext.Provider>
  )
}
